import { Action } from 'redux';

import { Airport } from '../../models/Flight/Airport';

import {
    AIRPORTS_REQUEST,
    AIRPORTS_RESPONSE,
    AIRPORTS_ERROR,

    SET_AIRPORT_FROM,
    SET_AIRPORT_TO,
    SET_AIRPORT_DIRECT,

    RESET_AIRPORT,

    SWAP_AIRPORTS
} from '../../actions/Flight/airports';

export interface AirportsState {
    selectedFrom?: Airport;
    selectedTo?: Airport;

    airports: Array<Airport>;
    error: string | null;
    loading: boolean;

    isDirect: boolean;
}

const initialState: AirportsState = {
    selectedFrom: undefined,
    selectedTo: undefined,

    airports: Array<Airport>(),
    loading: false,
    error: null,

    isDirect: false
};

export function airports(state: AirportsState = initialState, action: Action) {
    switch (action.type) {
        case SET_AIRPORT_DIRECT: {
            const isDirect = !!(action as any).isDirect;
            return {
                ...state,
                isDirect
            };
        }

        case SWAP_AIRPORTS: {
            return {
                ...state,
                selectedFrom: state.selectedTo,
                selectedTo: state.selectedFrom
            };
        }

        case SET_AIRPORT_FROM: {
            const selectedFrom = (action as any).airport;
            return {
                ...state,
                selectedFrom
            };
        }
        case SET_AIRPORT_TO: {
            const selectedTo = (action as any).airport;
            return {
                ...state,
                selectedTo
            };
        }
        case RESET_AIRPORT: {
            return {
                ...state,
                airports: initialState.airports
            };
        }

        case AIRPORTS_REQUEST: {
            return {
                ...state,
                airports: initialState.airports,
                loading: true,
                error: initialState.error
            };
        }
        case AIRPORTS_RESPONSE: {
            const resp = (action as any).response;
            return {
                ...state,
                airports: resp.result,
                loading: false
            };
        }
        case AIRPORTS_ERROR: {
            const error = (action as any).error;
            return {
                ...state,
                loading: false,
                error
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Flight/airports.ts